/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_SD_USER_INFO, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS } from './actionTypes';

import { fetchSdUserInfoUtil, fetchSdUserLocalOfficeAddressUtil } from './utils';

/**
 * Contains the action creator functions that update the ExternalUserInformation slice of the store.
 *
 * @namespace ExternalUserInformationActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_user_info
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ExternalUserInformationActions
   */
  static fetchSdUserInfo = (dispatch, callback) => {
    ReduxUtils.generateAction(dispatch, fetchSdUserInfoUtil, FETCH_SD_USER_INFO, callback);
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchSdUserInfo.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ExternalUserInformationActions
   */
  static resetFetchSdUserInfo = (dispatch, data) => {
    const json = {
      type: FETCH_SD_USER_INFO.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchSdUserInfo.
   *
   * @param {function} dispatch
   * @function
   * @memberof ExternalUserInformationActions
   */
  static resetFetchSdUserInfoError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_SD_USER_INFO.failureAction);
  };

  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_user_local_office_address
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ExternalUserInformationActions
   */
  static fetchSdUserLocalOfficeAddress = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchSdUserLocalOfficeAddressUtil,
      FETCH_SD_USER_LOCAL_OFFICE_ADDRESS,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchSdUserLocalOfficeAddress.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ExternalUserInformationActions
   */
  static resetFetchSdUserLocalOfficeAddress = (dispatch, data) => {
    const json = {
      type: FETCH_SD_USER_LOCAL_OFFICE_ADDRESS.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchSdUserLocalOfficeAddress.
   *
   * @param {function} dispatch
   * @function
   * @memberof ExternalUserInformationActions
   */
  static resetFetchSdUserLocalOfficeAddressError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS.failureAction);
  };
}
